import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api, AuditEntry } from '../lib/api';
import { absoluteTime, relativeTime } from '../lib/format';
import { ErrorState } from '../components/QueryState';

export function Audit() {
  const [action, setAction] = useState('');
  const [actor, setActor] = useState('');
  const params = new URLSearchParams({ limit: '200' });
  if (action) params.set('action', action);
  if (actor) params.set('actor', actor);
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['audit', action, actor],
    queryFn: () => api.get<{ entries: AuditEntry[] }>(`/audit/?${params.toString()}`),
  });
  return (
    <div className="space-y-4">
      <h1 className="text-xl font-semibold">Audit log</h1>
      <div className="flex flex-wrap gap-2 items-end">
        <label className="text-sm">
          <div className="text-muted">Action (exact)</div>
          <input className="input" value={action} onChange={(e) => setAction(e.target.value)} placeholder="e.g. client.enroll" />
        </label>
        <label className="text-sm">
          <div className="text-muted">Actor (exact)</div>
          <input className="input" value={actor} onChange={(e) => setActor(e.target.value)} />
        </label>
      </div>
      {isError && <ErrorState error={error} onRetry={() => refetch()} />}
      <section className="card overflow-auto">
        <table className="table">
          <thead>
            <tr><th>When</th><th>Action</th><th>Target</th><th>Actor</th><th>Details</th></tr>
          </thead>
          <tbody>
            {isLoading && <tr><td colSpan={5} className="text-muted">Loading…</td></tr>}
            {data?.entries.length === 0 && (
              <tr><td colSpan={5} className="text-muted">No entries match.</td></tr>
            )}
            {data?.entries.map((e) => (
              <tr key={e.id}>
                <td title={absoluteTime(e.ts)}>{relativeTime(e.ts)}</td>
                <td className="font-mono text-xs">{e.action}</td>
                <td className="font-mono text-xs">{e.target || ''}</td>
                <td>{e.actor || ''}</td>
                <td className="font-mono text-xs whitespace-pre-wrap max-w-md">
                  {e.details ? JSON.stringify(e.details) : ''}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </div>
  );
}
